import { useDispatch } from "react-redux"
import { FilterAndSortExpression } from "../Models/Client/FilterAndSortExpression"
import { APIGroundTruthModel } from "../Models/API/APIGroundTruthModel"
import { loadMoreGroundTruthList } from "../Actions/API/AppInstance/AppInstanceBaselineDataActions"
import { routePaths } from "../Routes"
import { State } from "../Reducers"
import { useNavigation, Navigation } from "./useNavigation"
import { useAppState } from "./useReduxState"
import { useCallback } from "react"

export function useGroundTruthListNavigation(
    orgUsername: string,
    appID: string,
    params: FilterAndSortExpression<APIGroundTruthModel>,
    groundTruthID?: string
): Navigation | undefined {
    const dispatch = useDispatch()
    const data = useAppState(
        (state: State) => state.api.baselineData.table[appID]
    )
    const onLoadMore = useCallback(
        () => dispatch(loadMoreGroundTruthList(appID)),
        [appID, dispatch]
    )
    const buildUrl = useCallback(
        (id: string) =>
            routePaths.appCustomizeBaselineDataDetail(
                orgUsername,
                appID,
                id,
                params
            ),
        [appID, orgUsername, params]
    )

    return useNavigation(data, buildUrl, onLoadMore, groundTruthID)
}
